export const PageType = {
    CURRENT_PAGE: 0,
    All_PAGE: 1
}